import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu", "openIcon", "closeIcon", "button"]

    connect() {
        // Ensure initial state is correct
        if (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
            this.close()
        }
    }

    toggle() {
        if (this.menuTarget.classList.contains("hidden")) {
            this.open()
        } else {
            this.close()
        }
    }

    open() {
        this.menuTarget.classList.remove("hidden")
        this.openIconTarget.classList.add("hidden")
        this.closeIconTarget.classList.remove("hidden")
        this.buttonTarget.setAttribute("aria-expanded", "true")
    }

    close() {
        this.menuTarget.classList.add("hidden")
        this.openIconTarget.classList.remove("hidden")
        this.closeIconTarget.classList.add("hidden")
        this.buttonTarget.setAttribute("aria-expanded", "false")
    }

    toggleSubmenu(event) {
        const btn = event.currentTarget
        const submenuId = btn.dataset.submenu
        const submenu = document.getElementById(submenuId)
        const chevron = btn.querySelector(".fa-chevron-down")

        if (submenu) {
            const isHidden = submenu.classList.contains("hidden")

            // Toggle visibility
            submenu.classList.toggle("hidden")

            // Rotate chevron
            if (chevron) {
                chevron.style.transform = isHidden ? "rotate(180deg)" : "rotate(0deg)"
            }
        }
    }
}
